import type { GameMode } from '@/state/types';

/**
 * Block B / B1 — Bauzeit-Hilfsfunktion.
 *
 * Wiki-Stunden werden mit BUILD_TIME_REAL_RATIO auf Echtzeit gerafft.
 * Kurze Tier-1-Bauten (≤ INSTANT_BUILD_THRESHOLD_HOURS) sind sofort fertig,
 * damit das initiale Spielerlebnis ohne Wartespiel startet.
 * Sandbox-Modus überspringt die Bauzeit grundsätzlich.
 */

export const BUILD_TIME_REAL_RATIO = 0.01;

/** Schwellwert in Wiki-Stunden, ≤ → instant. */
export const INSTANT_BUILD_THRESHOLD_HOURS = 0;

/**
 * Effektive Bauzeit in Millisekunden.
 *  - Sandbox: immer 0 (instant).
 *  - hours <= INSTANT_BUILD_THRESHOLD_HOURS: 0 (instant).
 *  - sonst: hours * 3_600_000 * BUILD_TIME_REAL_RATIO.
 */
export function getEffectiveBuildTimeMs(hours: number, mode: GameMode): number {
  if (mode === 'sandbox') return 0;
  if (hours <= INSTANT_BUILD_THRESHOLD_HOURS) return 0;
  return Math.round(hours * 3_600_000 * BUILD_TIME_REAL_RATIO);
}

/**
 * Convenience formatter for the UI: "12 h Wiki → 7,2 min Echtzeit"
 * (or "sofort" if instant).
 */
export function formatBuildTime(hours: number, mode: GameMode): string {
  const ms = getEffectiveBuildTimeMs(hours, mode);
  if (ms === 0) return 'sofort';
  const minutes = ms / 60_000;
  if (minutes < 1) return `${Math.round(ms / 1000)} s`;
  if (minutes < 10) return `${minutes.toFixed(1).replace('.', ',')} min`;
  return `${Math.round(minutes)} min`;
}
